// local
const initialState = {
    loading: false,
    data: null,
};

const ACTION_KEY = 'PATIENT_DETAIL';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case `${ACTION_KEY}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${ACTION_KEY}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${ACTION_KEY}_FULFILLED`: {
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        }
        default:
            return state;
    }
};

export default reducer;
